import router from "@/router"

import { GlobalVariables } from "@/helpers/globalVariables"

import type { ApiError } from "@/shared/apiClient"

export default class ErrorService {
  /**
   * Redirects to the login page if the error is 401 or 403, otherwise redirects to the error page.
   */
  static redirect(error: ApiError) {
    if (error.status === 401 || error.status === 403) {
      ErrorService.handleAuthErrors(error)
    } else {
      ErrorService.handleDefaultError()
    }
  }

  /**
   * Redirects to the login page.
   */
  private static handleAuthErrors(error: ApiError) {
    if (error.status === 401)
      router.push({ name: GlobalVariables.urls.login.routeName, query: { magicAuthFailed: "true" } })
    else router.push({ name: GlobalVariables.urls.login.routeName })
  }

  /**
   * Redirects to the error page.
   */
  private static handleDefaultError() {
    router.push({ name: GlobalVariables.urls.error.routeName })
  }
}
